module.exports = __webpack_public_path__ + "static/media/image3.e5dbe655.jpg";